// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290334/js/" + chunkId + "." + {"44":"31ca3a56","225":"1f22a8cb","481":"e3d254bb","486":"8e538fd1","770":"74f2d8b7"}[chunkId] + ".0.6315717015045796.chunk.js";
};